import {put, takeLatest, call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    ADD_OPTION,
    ADD_OPTION_SUCCESS,
    ADD_OPTION_ERROR
}
    from "../../../actions/menu/options";

function* addOptionSaga(action) {
    try {
        const data =  yield call(optionService.AddOption, action.payload)
        yield put({
            type: ADD_OPTION_SUCCESS,
            payload: data
        });

    } catch (error) {
        yield put({
            type: ADD_OPTION_ERROR,error: error.data
        });
    }
}


export function* addOptionSagaWatcher() {
    yield takeLatest(ADD_OPTION, addOptionSaga);
}